import React from "react";
import {Divider, Grid, InputBase, Typography} from "@material-ui/core";

export const FormTable = (props) => {
    const {config, getFieldProps} = props

    return (
        <Grid container direction={'column'} spacing={1}>
            {config.map(el => {
                return (
                    <React.Fragment key={el.id}>
                        <Grid container item>
                            <Grid container item alignItems={'center'}>
                                <Grid item xs={3}>
                                    <Typography variant={'subtitle2'}>{el.label}</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    {el.id !== 'content.null' ?
                                    <InputBase
                                        placeholder={el.label}
                                        fullWidth
                                        {...getFieldProps(el.id)}/>
                                    : 
                                    <InputBase
                                        placeholder={el.label}
                                        fullWidth
                                        disabled={true}
                                        {...getFieldProps(el.id)}/>
                                    }   
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider/>
                    </React.Fragment>
                )
            })}
        </Grid>
    )
}